// extracted by mini-css-extract-plugin
export default {"detailElement":"styles_detailElement__4o48z"};